import createActionType from "../../utils/createActionType";

export const MODULE = "planner/progress-filter";

export const SET_SELECTED_PROGRESS = createActionType(MODULE, "setSelectedProgress");

export const RESET = createActionType(MODULE, "reset");
